import { useState } from "react";
import { images } from "../../assets/Images/assetsImages";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from 'react-router-dom';

const NavBar = () => {

  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(null);

    const navbarLeftItems = [
        {
          name: "Company",
          type: "Dropdown",
          items: [
            { name: "About Us", link: "/about" },
            { name: "Catering", link: "/catering" },
            { name: "Gallery", link: "/gallery"  },
          ],
        },
        {
          name: "Categories",
          type: "Dropdown",
          items: [
            { name: "Breakfast",  link: "/breakfast" },
            { name: "Salads", link: "/salads" },
            { name: "Sandwiches", link: "/sandwiches" },
            { name: "Savory Pies", link: "/savory-pies" },
            { name: "Pasta", link: "/pasta" },
            { name: "Mains", link: "/mains" },
            { name: "Viennoiserie", link: "/viennoiserie" },
            { name: "Danish Pastries", link: "/danish-pastries" },
            { name: "Artisanal Bread", link: "/artisans" },
            { name: "Pies & Tarts", link: "/pies-tarts" },
            { name: "Cakes",  link: "/cakes" },
            { name: "Cupcakes", link: "/cupcakes" },
            { name: "Cookies & Bars",  link: "/cookies-bars" },
            { name: "Bombolone",  link: "/bombolones" },
            { name: "Cheesecakes",  link: "/cheesecakes" },
            { name: "Chilled Desserts",  link: "/chilled-desserts" },
            { name: "Tres Leches",  link: "/tres-leches" },
            { name: "Gelato",  link: "/gelato" },
            { name: "Coffee & Tea",  link: "/coffee-tea" },
            { name: "Smoothies & Milkshakes",  link: "/someethies-milkshakes" },
            { name: "Juices & Mocktails",  link: "/juices-mocktails" },
            { name: "Water & Soft drinks",  link: "/water-softdrinks" },
          ],
        },
      ];

      const navbarRightItems = [
        { name: "Atelier", type: "Link", link: "/atelier" },
        { name: "Contact Us", type: "Link", link: "/contact-us" },
      ];

  return (
    <section className="fixed top-[-2px] left-0 z-50 w-full h-[80px] md:h-[155px] 2xl:h-[185px] 3xl:h-[220px]">
      <div className="w-full h-full relative ">
        <img
          src={images.NavBarMobile}
          alt="navbar"
          className="md:hidden w-full h-full object-cover"
        />
        <img
          src={images.NavBarBg}
          alt="navbar"
          className="hidden md:block w-full h-full object-cover"
        />

        <Link to="/">
          <img
            src={images.Logo}
            alt="logo"
            className="absolute top-0 left-2 w-[30%] h-[100%] object-contain md:hidden"
          />
        </Link>

        <div
          className="absolute right-4 top-4 text-[#41220E] text-[30px] sm:text-[33px] md:text-[36px] cursor-pointer md:hidden"
          onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>

      <div className="absolute top-0 left-0 w-full h-full hidden md:flex">
        <div className="absolute top-0 left-0 w-full h-full flex">

          <div className="w-[40%] flex">
            <ul className='w-[90%] lg:w-[80%] h-[65%] px-[15%] justify-between font-montserrat font-bold text-[#41220E] text-[14px] lg:text-[16px] xl:text-[20px] items-center flex'>
              {navbarLeftItems.map((item) => 
                <li key={item.name} className='relative group hover:text-[#714E16] cursor-pointer transition-all duration-200 ease-linear'>
                  {item.name}

                  <ul className="absolute left-0 hidden bg-white text-[#41220E] font-normal group-hover:block shadow-lg w-[250px] max-h-[400px] overflow-y-auto scrollbar-thin scrollbar-thumb-[#714E16] scrollbar-track-[#f5e9d7]">
                    {item.items.map((dropdownItem) => (
                      <li
                        key={dropdownItem.name}
                        className="px-4 py-2 text-md hover:bg-[#714E16] cursor-pointer hover:text-[#F5E9D7]"
                      >
                        <Link to={dropdownItem.link}>{dropdownItem.name}</Link>
                      </li>
                    ))}
                  </ul>
                </li>
              )}
            </ul>
          </div>

          <div className="w-[40%] xl:w-[30%] 2xl:w-[20%] flex justify-center items-center">
            <Link to="/">
              <img
                src={images.Logo}
                alt="logo"
                className="w-full h-full object-contain"
              />
            </Link>
          </div>

          <div className="w-[40%] flex justify-end">
            <ul className='w-[90%] lg:w-[80%] h-[65%] px-[15%] justify-between font-montserrat font-bold text-[#41220E] text-[14px] lg:text-[16px] xl:text-[20px] items-center flex'>
              {navbarRightItems.map((item) => 
                <li key={item.name} className='hover:text-[#714E16] cursor-pointer hover:transition-all hover:duration-200 hover:ease-linear'>
                  <Link to={item.link}>
                    {item.name}
                  </Link>
                </li>
              )}
            </ul>
          </div>
          
        </div>
      </div>

      {menuOpen && (
        <div
          className="fixed top-[65px] right-0 z-50 w-full h-full bg-[#F5E9D7] shadow-lg transition-transform duration-300 transform md:hidden"
          style={{ transform: menuOpen ? "translateX(0)" : "translateX(100%)" }}
        >
          <ul className="flex flex-col items-start space-y-6 p-6 font-montserrat font-bold text-[#41220E] max-h-screen overflow-y-auto scrollbar-thin scrollbar-thumb-[#714E16] scrollbar-track-[#f5e9d7]">
            {navbarLeftItems.map((item, index) => (
              <li key={item.name} className="w-full">
                <div
                  className="flex justify-between items-center cursor-pointer text-lg"
                  onClick={() =>
                    setDropdownOpen((prev) => (prev === index ? null : index))
                  }
                >
                  {item.name}
                  {item.type === "Dropdown" && (
                    <span className="text-sm text-[#41220E]">
                      {dropdownOpen === index ? "-" : "+"}
                    </span>
                  )}
                </div>
                {item.type === "Dropdown" && dropdownOpen === index && (
                  <ul className="pl-6 mt-2 space-y-2">
                    {item.items.map((dropdownItem) => (
                      <li
                        key={dropdownItem.name}
                        className="text-md hover:text-[#714E16] cursor-pointer"
                      >
                        <Link to={dropdownItem.link}>
                            {dropdownItem.name}
                          </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}

            {navbarRightItems.map((item) => (
              <li
                key={item.name}
                className="text-lg hover:text-[#D4A373] cursor-pointer"
              >
                <Link to={item.link}>
                    {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}

    </section>

  )
}

export default NavBar
